'use es6';

import createAction from 'flux-actions/createAction';
import { REQUESTED_CONTENT_USAGE_LIMITS, REQUESTED_CONTENT_USAGE_LIMITS_FAILED, RECEIVED_CONTENT_USAGE_LIMITS, REQUESTED_BLOG_USAGE_LIMITS, REQUESTED_BLOG_USAGE_LIMITS_FAILED, RECEIVED_BLOG_USAGE_LIMITS } from './ActionTypes';
import { ContentTypes } from '../constants/base';
export const requestedContentUsage = createAction(REQUESTED_CONTENT_USAGE_LIMITS);
export const receivedContentUsage = createAction(RECEIVED_CONTENT_USAGE_LIMITS, (data, contentType, shouldFetchFromSharedPageLimitApi, isUngatedForApplySharedPageLimits) => {
  if (shouldFetchFromSharedPageLimitApi) {
    const limitName = contentType === ContentTypes.LANDING_PAGE ? 'cms-landing-pages' : 'cms-site-pages';
    const sharedPageLimitData = data.find(limitsData => limitsData.limitName === 'cms-pages');
    const isApplyingSharedPageLimit = isUngatedForApplySharedPageLimits && !!sharedPageLimitData;
    const pageTypeLimitsData = isApplyingSharedPageLimit ? sharedPageLimitData : data.find(limitsData => limitsData.limitName === limitName);
    return {
      isApplyingSharedPageLimit,
      limit: pageTypeLimitsData.limit,
      quantityUsed: pageTypeLimitsData.quantityUsed
    };
  }
  return {
    limit: data.limit || data.pageLimit,
    quantityUsed: data.quantityUsed
  };
});
export const receivedContentUsageFailure = createAction(REQUESTED_CONTENT_USAGE_LIMITS_FAILED, error => ({
  error
}));
export const requestedBlogUsage = createAction(REQUESTED_BLOG_USAGE_LIMITS);
export const receivedBlogUsage = createAction(RECEIVED_BLOG_USAGE_LIMITS, data => ({
  limit: data.limit,
  quantityUsed: data.quantityUsed
}));
export const receivedBlogUsageFailure = createAction(REQUESTED_BLOG_USAGE_LIMITS_FAILED, error => ({
  error
}));